var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, computed, action } from 'mobx';
import { Filters } from 'utils';
let AudienceFiltersStore = (_class = class AudienceFiltersStore {
  constructor() {
    this.filterGroup = 'audienceFilters';
    _initializerDefineProperty(this, "audienceGenders", _descriptor, this);
    _initializerDefineProperty(this, "audienceAges", _descriptor2, this);
    _initializerDefineProperty(this, "audienceCountries", _descriptor3, this);
    this.audienceFilterKeys = ['audienceGenders', 'audienceAges', 'audienceCountries'];
    this.getLabels = filter => Array.isArray(filter) ? filter.map(f => f.label).join(', ') : filter.label;
  }
  get audienceFilters() {
    return {
      audienceGenders: this.audienceGenders,
      audienceAges: this.audienceAges,
      audienceCountries: this.audienceCountries
    };
  }
  changeAudienceFilter(filter, value) {
    this[filter] = value;
  }
  setAudienceFilters({
    audienceGenders,
    audienceAges,
    audienceCountries
  }) {
    if (audienceGenders) this.audienceGenders = audienceGenders;
    if (audienceAges) this.audienceAges = audienceAges;
    if (audienceCountries) this.audienceCountries = audienceCountries;
  }
  resetAudienceFilter() {
    this.audienceGenders = Filters.getDefaultFilter({
      group: this.filterGroup,
      filter: 'audienceGenders'
    });
    this.audienceAges = Filters.getDefaultFilter({
      group: this.filterGroup,
      filter: 'audienceAges'
    });
    this.audienceCountries = Filters.getDefaultFilter({
      group: this.filterGroup,
      filter: 'audienceCountries'
    });
    return {
      audienceGenders: this.audienceGenders,
      audienceAges: this.audienceAges,
      audienceCountries: this.audienceCountries
    };
  }
  getAudienceLabels() {
    return {
      audienceGenders: '',
      audienceAges: '',
      audienceCountries: ''
    };
  }
  getAudienceVariables({
    countryKey = 'country',
    agesKey = 'ages',
    gendersKey = 'genders',
    omitVariableKeys = true,
    newCountryType = false
  } = {}) {
    const ages = Array.isArray(this.audienceAges) ? this.audienceAges.map(f => f.value).filter(Boolean) : this.audienceAges.value || [];
    const genders = Array.isArray(this.audienceGenders) ? this.audienceGenders.map(f => f.value).filter(Boolean) : this.audienceGenders.value || [];

    // some graphQL queries (e.g. topics query) enforces the client to send an audience object with all the keys
    // while in other queries (most of the cases) it is better to omit those keys.
    if (!omitVariableKeys) {
      return {
        [gendersKey]: genders,
        [agesKey]: ages,
        [countryKey]: this.audienceCountries.value || []
      };
    }
    return {
      ...((genders.length || genders.value) && {
        [gendersKey]: genders
      }),
      ...((ages.length || ages.value) && {
        [agesKey]: ages
      }),
      ...((this.audienceCountries.length || this.audienceCountries.value) && {
        [countryKey]: this.audienceCountries.value || [],
        ...(newCountryType && {
          country: this.audienceCountries.value || ''
        })
      })
    };
  }
  getAudienceDescription() {
    return `${this.getLabels(this.audienceCountries)}, ${this.getLabels(this.audienceGenders)}, ${this.getLabels(this.audienceAges)}`;
  }
  getActiveAudienceDescription() {
    const audienceObj = this.getAudienceVariables();
    if (Object.keys(audienceObj).length === 0) return 'All';
    const activeAudienceFiltersLabels = Object.keys(audienceObj).map(audienceFilterKey => {
      switch (audienceFilterKey) {
        case 'genders':
          return this.getLabels(this.audienceGenders);
        case 'ages':
          return this.getLabels(this.audienceAges);
        case 'country':
          return this.getLabels(this.audienceCountries);
        default:
          return null;
      }
    });
    return activeAudienceFiltersLabels.join();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "audienceGenders", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Filters.getDefaultFilter({
      group: this.filterGroup,
      filter: 'audienceGenders'
    });
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "audienceAges", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Filters.getDefaultFilter({
      group: this.filterGroup,
      filter: 'audienceAges'
    });
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "audienceCountries", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Filters.getDefaultFilter({
      group: this.filterGroup,
      filter: 'audienceCountries'
    });
  }
}), _applyDecoratedDescriptor(_class.prototype, "audienceFilters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "audienceFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeAudienceFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeAudienceFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAudienceFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAudienceFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetAudienceFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetAudienceFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getAudienceLabels", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getAudienceLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getAudienceVariables", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getAudienceVariables"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getAudienceDescription", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getAudienceDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getActiveAudienceDescription", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getActiveAudienceDescription"), _class.prototype), _class);
export default new AudienceFiltersStore();